import React, { useEffect, useState } from 'react';
import { Container, Table, Spinner, Button, Modal } from 'react-bootstrap';
import DynamicCloseButton from './DynamicCloseButton';
import { get } from '../utils/api';
import { CURRENCY_SYMBOL } from '../config';

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const { data } = await get('/orders/my');
        setOrders(data);
      } catch (error) {
      }
      setLoading(false);
    };

    fetchOrders();
  }, []);

  const handleShowModal = async (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    try {
      const { data } = await get(`/orders/${order.order_id}`);
      setSelectedOrder(data);
    } catch (error) {
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container>
      <h2 className="my-4">My Orders</h2>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Order Date</th>
            <th>Total Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.length > 0 ? (
            orders.map((order) => (
              <tr key={order.order_id}>
                <td>{order.order_id}</td>
                <td>{formatDate(order.order_date)}</td>
                <td>{CURRENCY_SYMBOL}{order.total_amount}</td>
                <td>{order.status.toUpperCase()}</td>
                <td>
                  <Button variant="info" size="sm" onClick={() => handleShowModal(order)}>
                    View Details
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">No orders found.</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header>
          <Modal.Title>Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrder ? (
            <div>
              <p><strong>Order ID:</strong> {selectedOrder.order_id}</p>
              <p><strong>Order Date:</strong> {formatDate(selectedOrder.order_date)}</p>
              <p><strong>Order Type:</strong> {selectedOrder.order_type}</p>
              <p><strong>Total Amount:</strong> {CURRENCY_SYMBOL}{selectedOrder.total_amount}</p>
              <p><strong>Status:</strong> {selectedOrder.status.toUpperCase()}</p>
              <h5>Items</h5>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Medicine Name</th>
                    <th>Quantity</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrder.items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.medicine_name}</td>
                      <td>{item.quantity}</td>
                      <td>{CURRENCY_SYMBOL}{item.price}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <Spinner animation="border" />
          )}
        </Modal.Body>
        <Modal.Footer>
          <DynamicCloseButton variant="secondary" onClick={handleCloseModal}>Close</DynamicCloseButton>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MyOrders;
